import { FunctionComponent } from 'react'

const NotFound: FunctionComponent = () => {
  return (
    <div>
      <p>Error: Page does not exist!</p>
    </div>
  )
}

export default NotFound
